import { connect } from 'react-redux'
import {
  setIsSidebarVisible
} from 'store/redux/layout'
import MenuItem from './MenuItem'

export default connect(
  null,
  {
    setIsSidebarVisible,
  },
  null,
  {
    forwardRef: true,
  }
)(MenuItem)
